<template>
  <Teleport to="body">
    <dialog
      ref="panel"
      class="lightbox"
      aria-label="Arbeit in voller Ansicht"
      @cancel.prevent="close"
      @keydown.left.prevent="move(-1)"
      @keydown.right.prevent="move(1)"
    >
      <template v-if="visible && current">
        <div class="lightbox-bar">
          <span class="eyebrow"
            >{{ kind === 'admin' ? 'Bilderverwaltung' : kind === 'art' ? 'Soul Art' : 'Fineline & Blackwork' }} · White Pearl Ink</span
          ><button class="icon-button" aria-label="Bildansicht schliessen" @click="close">
            <InkIcon name="close" />
          </button>
        </div>
        <div class="lightbox-stage" @touchstart.passive="startTouch" @touchend.passive="endTouch">
          <img :key="current.src" :src="current.src" :alt="current.title" draggable="false" />
          <button
            v-if="images.length > 1"
            class="icon-button lightbox-prev"
            aria-label="Vorheriges Bild"
            @click="move(-1)"
          >
            <InkIcon name="back" />
          </button>
          <button
            v-if="images.length > 1"
            class="icon-button lightbox-next"
            aria-label="Nächstes Bild"
            @click="move(1)"
          >
            <InkIcon name="arrow" />
          </button>
        </div>
        <div class="lightbox-bottom">
          <p aria-live="polite">{{ index + 1 }} / {{ images.length }} · {{ current.title }}</p>
          <router-link
            v-if="kind === 'tattoo'"
            :to="{ path: '/anfrage', query: { motif: current.src } }"
            class="button button-light"
            @click="close"
            >Ähnliches Motiv anfragen <InkIcon name="diagonal"
          /></router-link>
          <a v-else-if="kind === 'art'" :href="artMail" class="button button-light"
            >Zu diesem Bild anfragen <InkIcon name="diagonal"
          /></a>
        </div>
      </template>
    </dialog>
  </Teleport>
</template>
<script setup>
import { ref, computed, nextTick, onBeforeUnmount } from 'vue';
import InkIcon from './InkIcon.vue';
const props = defineProps({
  images: { type: Array, default: () => [] },
  kind: { type: String, default: 'tattoo' },
});
const panel = ref(null);
const visible = ref(false);
const index = ref(0);
const current = computed(() => props.images[index.value]);
const artMail = computed(
  () =>
    'mailto:rebecca.sophiaa.p@gmail.com?subject=' +
    encodeURIComponent('Anfrage Kunstwerk') +
    '&body=' +
    encodeURIComponent(
      'Hallo Rebecca, ich interessiere mich für dieses Kunstwerk: ' +
        (current.value ? new URL(current.value.src, location.origin).href : '')
    )
);
let overflow = '';
let touch = null;
const open = async (value) => {
  if (!props.images[value]) return;
  index.value = value;
  visible.value = true;
  overflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  await nextTick();
  panel.value.showModal();
};
const close = () => {
  panel.value?.close();
  if (visible.value) document.body.style.overflow = overflow;
  visible.value = false;
};
const move = (direction) => {
  index.value = (index.value + direction + props.images.length) % props.images.length;
};
const startTouch = (event) => {
  const point = event.changedTouches[0];
  touch = { x: point.clientX, y: point.clientY };
};
const endTouch = (event) => {
  if (!touch || props.images.length < 2) return;
  const point = event.changedTouches[0];
  const x = point.clientX - touch.x,
    y = point.clientY - touch.y;
  if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.4) move(x < 0 ? 1 : -1);
  touch = null;
};
onBeforeUnmount(close);
defineExpose({ open });
</script>
